<template>
  <span>
    <v-progress-circular indeterminate color="primary" v-if="generating"></v-progress-circular>
    <v-icon @click="generateActivationCode" size="30" v-else color="blue dark-2">
      mdi-folder-key-network-outline
    </v-icon>
  </span>
</template>
<script>
export default {
  props: {
    register: {
      required: true,
      type: Object,
    },
  },
  data: () => ({ generating: false }),
  methods: {
    generateActivationCode() {
      window.Notify.confirm(
        'This action will generate a new activation code for a register and send them an email',
        'Generate Register code?',
      ).then(() => {
        this.generating = true;
        this.$http
          .post(`api/v1/registers/${this.register.global_id}/activationCode`)
          .then(({ register }) => {
            this.generating = false;
            this.$emit('update:register', register);
            window.Notify.success('Activation code was generated & sent successfully');
          })
          .catch(error => {
            this.generating = false;
            this.showResponseError(error);
          });
      });
    },
  },
};
</script>
